(function () {
  'use strict';
  angular.module('finance.vckkcat')
    .component('kkcatnew', {
      restrict: 'E',
      bindings: {
      },
      template: `
      <div class="kkcatnew-component" data-hook="kkcatnew-component">
        <h3>Neue/s kkcat anlegen</h3>
        <div class="btn btn-success" ng-click="vm.addKkcat()" ng-hide="vm.newkkcat">Neue/s kkcat anlegen</div>
        <div ng-show="vm.newkkcat">
          <kkcatform kkcat="vm.newkkcat" parentsave="vm.saveNewKkcat(kkcat)" oncancel="vm.cancel()"></kkcatform>
        </div>
        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> kkcat erfolgreich angelegt!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Anlegen eines/r neuen kkcat wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> kkcat konnte nicht angelegt werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Kkcat', 'Rlog',
        function ($log, Kkcat, Rlog) {
          let vm = this;
          vm.addKkcat = addKkcat;
          vm.saveNewKkcat = saveNewKkcat;
          vm.cancel = cancel;
          
          function addKkcat() {
            vm.newkkcat = {};
            delete vm.created;
            delete vm.canceled;
          }
          
          function saveNewKkcat(kkcat) {
            $log.debug('debug: create new kkcat: ', kkcat);
            delete vm.newkkcat;
            Kkcat.$create(kkcat).$then(function () {
              vm.created = true;
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new kkcat failed: ', err);
              Rlog.error('vcutils.kkcat', 'kkcatnew', 'Creation of new kkcat failed: ', {error: err, kkcat: vm.newkkcat});
            });
          }
          
          function cancel() {
            delete vm.newkkcat;
            vm.canceled = true;
          }
        }] // controller
    }); // component

// klammerfriedhof
}());